/**
 * Created by Jiu Chen on 12/03/2018.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, forkJoin } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { EntryTypeActionTypes } from '../actions/entry-type.actions';

import { EntryType } from '@tamalelibs/models/entry-type.model';
import { EntryTypeService } from '@tamalelibs/services/entry-type.service';

@Injectable()
export class EntryTypeEffects {

    constructor(
        private _actions$: Actions,
        private _entryTypeService: EntryTypeService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EntryTypeActionTypes.INITIALIZE),
        switchMap(() => {
            const observableArray = [];
            observableArray.push(this._entryTypeService.getAvailableList());
            observableArray.push(this._entryTypeService.getFullList());
            observableArray.push(this._entryTypeService.getDefaultEntryType());

            return forkJoin(observableArray).pipe(
                map((responses: any) => {
                    const availableEntryTypeList = responses[0]['entry-type-list'].map(item => new EntryType(item.id, item.name, item.useNER, item.href, item.usage, item.config));
                    const fullEntryTypeList = responses[1]['entry-type-list'].map(item => new EntryType(item.id, item.name, item.useNER, item.href, item.usage, item.config));
                    const defaultEntryType = new EntryType(responses[2].id, responses[2].name);
                    return {
                        type: EntryTypeActionTypes.INITIALIZE_SUCCESS,
                        payload: {
                            available: availableEntryTypeList,
                            full: fullEntryTypeList,
                            default: defaultEntryType
                        }
                    };
                })
            );
        })
    ));
}
